export default __webpack_public_path__ + "1eddd10c739bbf4ab01971c8ac374d17.svg";